export default __webpack_public_path__ + "static/media/brand-awareness-media-traffic.28ede7c7.svg";